import React from "react";
import {ProductListFilterItemRange} from "../../typescript-library";
import {useTranslation} from "react-i18next";
import {currencyUnit} from "../../helpers/intlFormatters";

const RangeTitle: React.FC<{item: ProductListFilterItemRange; className: string}> = ({item, className}) => {
  const {t} = useTranslation();
  if (item.field === "price") {
    return (
      <>
        {item.count ? (
          <>
            {t("product.price--currency", {currency: currencyUnit})}
            <span className={className} aria-hidden>
              ({item.count})
            </span>
            <span className="visually-hidden">{`, ${item.count} ${t("product.items")}`}</span>
          </>
        ) : (
          t("product.priceInBrackets--currency", {currency: currencyUnit})
        )}
      </>
    );
  }

  return (
    <>
      {item.count ? (
        <>
          {item.name || t(item.field)} <span className={className}>({item.count})</span>
        </>
      ) : (
        item.name || t(item.field)
      )}
    </>
  );
};

export default RangeTitle;
